const SearchForm = (props) => {
    return (
        <div>
            <form onSubmit={props.handleSubmit}>
                <label htmlFor="searchInput">Zoeken op Naam:</label><br />
                <input className="form-control" type="text" id="searchInput" value={props.searchStr} onChange={props.handleSearch} placeholder="Minimaal twee tekens"/>
            </form>
        </div>
    )
}

export default SearchForm